<template>
    <div class="content-card mb-4">
        <div class="content-card-title">จำนวนเพื่อนที่เราแนะนำ</div>
        <div class="content-card-body">
            <h2 class="mb-0">{{ getDownline || '' }}</h2>
            <p class="text-medium mb-0">จำนวนสมาชิกที่แนะนำทั้งหมด
            </p>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    getDownline: {
      type: String,
      default: '0.00'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    numberWithCommas (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
    ...mapGetters(['getIsVip'])
  }
}
</script>
